import React from 'react';
import type { CSSProperties } from 'react';

export interface IIconProps {
    className?: string;
    style?: CSSProperties;
}

function IconAppleShare(props: IIconProps): JSX.Element {
    return (
        <svg
            style={props.style ?? {}}
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="chevron-left"
            className={`${props.className ?? ''} svg-inline--fa fa-chevron-left fa-w-10`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 26 35"
        >
            <g id="Icon-Share-Apple" fill="currentColor">
                <polyline
                    id="Fill-1"
                    points="18.343 8.658 13 3.315 7.657 8.658 6.343 7.342 13 0.685 19.657 7.342 18.343 8.658"
                ></polyline>
                <polygon id="Fill-2" points="12 2 14 2 14 23 12 23"></polygon>
                <path
                    d="M23,35 L3,35 C1.346,35 0,33.654 0,32 L0,14 C0,12.346 1.346,11 3,11 L10,11 L10,13 L3,13 C2.448,13 2,13.449 2,14 L2,32 C2,32.551 2.448,33 3,33 L23,33 C23.552,33 24,32.551 24,32 L24,14 C24,13.449 23.552,13 23,13 L16,13 L16,11 L23,11 C24.654,11 26,12.346 26,14 L26,32 C26,33.654 24.654,35 23,35"
                    id="Fill-3"
                ></path>
            </g>
        </svg>
    );
}

export default IconAppleShare;
